import { defaultStyles } from "./UICustomizationStyles/defaultStyles"
import { type UICustomizationData } from "./types"

const isStyleMap = (value: unknown): value is UICustomizationData["styles"] =>
  typeof value === "object" &&
  value !== null &&
  !Array.isArray(value) &&
  Object.values(value).every((styleValue) => typeof styleValue === "string")

export const normalizeUICustomizationStyles = (styles: unknown): UICustomizationData["styles"] => {
  if (!isStyleMap(styles)) throw new Error("invalid_ui_customization_styles")

  return { ...defaultStyles, ...styles }
}

export const parseUICustomizationStyles = (styles: string): UICustomizationData["styles"] =>
  normalizeUICustomizationStyles(styles.trim() ? JSON.parse(styles) : {})
